"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteListQueryOrderDirectionEnum = exports.SiteListQueryOrderFieldEnum = void 0;
exports.SiteListQueryOrderFromJSON = SiteListQueryOrderFromJSON;
exports.SiteListQueryOrderFromJSONTyped = SiteListQueryOrderFromJSONTyped;
exports.SiteListQueryOrderToJSON = SiteListQueryOrderToJSON;
exports.SiteListQueryOrderToJSONTyped = SiteListQueryOrderToJSONTyped;
/**
* @export
* @enum {string}
*/
var SiteListQueryOrderFieldEnum;
(function (SiteListQueryOrderFieldEnum) {
    SiteListQueryOrderFieldEnum["Name"] = "name";
    SiteListQueryOrderFieldEnum["Views"] = "views";
    SiteListQueryOrderFieldEnum["Topn"] = "topn";
    SiteListQueryOrderFieldEnum["Sequence"] = "sequence";
    SiteListQueryOrderFieldEnum["Manual"] = "manual";
})(SiteListQueryOrderFieldEnum || (exports.SiteListQueryOrderFieldEnum = SiteListQueryOrderFieldEnum = {})); /**
* @export
* @enum {string}
*/
var SiteListQueryOrderDirectionEnum;
(function (SiteListQueryOrderDirectionEnum) {
    SiteListQueryOrderDirectionEnum["Asc"] = "asc";
    SiteListQueryOrderDirectionEnum["Desc"] = "desc";
    SiteListQueryOrderDirectionEnum["Random"] = "random";
})(SiteListQueryOrderDirectionEnum || (exports.SiteListQueryOrderDirectionEnum = SiteListQueryOrderDirectionEnum = {}));
function SiteListQueryOrderFromJSON(json) {
    return SiteListQueryOrderFromJSONTyped(json, false);
}
function SiteListQueryOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'field': json['field'],
        'direction': json['direction'],
    };
}
function SiteListQueryOrderToJSON(value) {
    return SiteListQueryOrderToJSONTyped(value, false);
}
function SiteListQueryOrderToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field': value.field,
        'direction': value.direction,
    };
}
